// extracted by mini-css-extract-plugin
export default {"authorCard":"hbXicCo_","wrapper":"JChPw47M","desktop":"desktop","mobile":"mobile","name":"Shv9A6mJ","allAuthorsLink":"ti_ztEtj","job":"l0Xp3iAU","socialNetworks":"hiWt2d8b"};